<template>
  <AppCard height="100vh">
    <slot></slot>
  </AppCard>
</template>

<script>
import AppCard from "@/components/library/container/AppCard";
export default {
name: "Auth",
  components: {AppCard}
}
</script>